/**
 * Firebase Configuration Diagnostics
 *
 * Use this utility to verify Firebase configuration is properly loaded
 * Run this in browser console: window.checkFirebaseConfig()
 */

export const checkFirebaseConfig = () => {
  console.group('🔥 Firebase Configuration Diagnostics');

  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  console.log('Environment Variables:', {
    apiKey: config.apiKey ? '✅ Set (' + config.apiKey.substring(0, 10) + '...)' : '❌ Missing',
    authDomain: config.authDomain ? '✅ ' + config.authDomain : '❌ Missing',
    projectId: config.projectId ? '✅ ' + config.projectId : '❌ Missing',
    storageBucket: config.storageBucket ? '✅ ' + config.storageBucket : '❌ Missing',
    messagingSenderId: config.messagingSenderId ? '✅ Set' : '❌ Missing',
    appId: config.appId ? '✅ Set (' + config.appId.substring(0, 15) + '...)' : '❌ Missing',
  });

  const missingVars = Object.entries(config)
    .filter(([key, value]) => !value)
    .map(([key]) => `VITE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`);

  if (missingVars.length > 0) {
    console.error('❌ Missing environment variables:', missingVars);
    console.log('\n📋 Action Required:');
    console.log('1. Check .env.local file exists in project root');
    console.log('2. Verify all VITE_FIREBASE_* variables are set');
    console.log('3. Restart development server after changes');
    console.log('4. For Vercel: Add variables in Settings > Environment Variables');
  } else {
    console.log('✅ All environment variables are set');
    console.log('\n🔍 Next Steps if authentication fails:');
    console.log('1. Verify Google Sign-In is enabled in Firebase Console');
    console.log('2. Check domain is authorized in Firebase Authentication settings');
    console.log('3. See FIREBASE_SETUP.md for detailed instructions');
  }

  console.groupEnd();
  return config;
};

// Make available in browser console
if (typeof window !== 'undefined') {
  window.checkFirebaseConfig = checkFirebaseConfig;
}
